export default __webpack_public_path__ + "static/media/icn_heart_red.0368e4e8.svg";